import classNames from "classnames";
import * as React from "react";

import { Goto } from "@/shared/navigation";
import { Principal } from "@/shared/principal";

import { RobotoLinkHoverUnderline } from "../RobotoLinkHoverUnderline";

import styles from "./RobotoPrincipalUnderlineLink.module.css";

interface RobotoPrincipalUnderlineLinkProps {
  principal: Principal | string;
  className?: classNames.Argument;
}

const linkTextAndLinkToFromPrincipal = (
  principal: Principal | string,
): {
  linkText: string;
  linkTo: string;
} => {
  let principalAsObj: Principal;

  if (typeof principal === "string") {
    const principalFromStr = Principal.fromString(principal).ok;
    if (!principalFromStr) {
      return {
        linkTo: "#",
        linkText: principal,
      };
    }
    principalAsObj = principalFromStr;
  } else {
    principalAsObj = principal;
  }

  switch (principalAsObj.ptype) {
    case "device":
      return {
        linkTo: Goto.createDeviceRoute(principalAsObj.unqualifiedId),
        linkText: principalAsObj.unqualifiedId,
      };
    case "integration":
      return {
        linkTo:
          principalAsObj.id === "foxglove-import"
            ? Goto.route.Settings.Integrations.Foxglove
            : "#",
        linkText: principalAsObj.id,
      };
    case "invocation":
      return {
        linkTo: Goto.createInvocationRoute(principalAsObj.id),
        linkText: principalAsObj.id,
      };
    case "user":
      return {
        linkTo: Goto.createUserRoute(principalAsObj.id),
        linkText: principalAsObj.id,
      };
    case "org":
      // The org's page renders its content for System users only; anyone else
      // would land on its breadcrumbs above an empty body.
      return {
        linkTo: "#",
        linkText: principalAsObj.id,
      };
    default:
      return {
        linkTo: "#",
        linkText: principalAsObj.id,
      };
  }
};

export const RobotoPrincipalUnderlineLink: React.FC<
  RobotoPrincipalUnderlineLinkProps
> = ({ principal, className }) => {
  const { linkTo, linkText } = linkTextAndLinkToFromPrincipal(principal);

  return (
    <div className={classNames(styles.container, className)}>
      <RobotoLinkHoverUnderline to={linkTo}>
        {linkText}
      </RobotoLinkHoverUnderline>
    </div>
  );
};
